"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var isEmpty = function isEmpty(contentItem) {
  var emptyTextValues = contentItem.filter(function (item) {
    return item.text.length === 0;
  });
  return emptyTextValues.length > 0;
};

var _default = isEmpty;
exports["default"] = _default;